import script from "./SecPlainList.vue?vue&type=script&setup=true&lang=js"
export * from "./SecPlainList.vue?vue&type=script&setup=true&lang=js"

import "./SecPlainList.vue?vue&type=style&index=0&id=5448aeee&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5448aeee"]])

export default __exports__